/* Pasquale Jimmy - movimento e microinterazioni.
   Nessuna dipendenza. Si disattiva da solo se l'utente chiede movimento ridotto. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) {
    root.classList.add('pj-motion-off');
    return;
  }

  root.classList.add('pj-js');

  /* Se qualcosa va storto, dopo 2,5 secondi si mostra comunque tutto. */
  window.setTimeout(function () {
    root.classList.add('pj-reveal-all');
  }, 2500);

  /* ---- Selettori che ricevono la comparsa progressiva ---- */
  var REVEAL = [
    '.pj-steps__head',
    '.pj-steps__item',
    '.pj-figures__item',
    '.pj-assure__col',
    '.pj-guards',
    '.pj-spec',
    '.media-with-content .group-block-content > *',
    '.section .group-block-content > .text-block'
  ].join(',');

  function markReveals(scope) {
    var groups = {};
    scope.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.hasAttribute('data-pj-reveal')) return;
      if (el.closest('.hero')) return; /* l'hero resta immediato */
      el.setAttribute('data-pj-reveal', '');
      var section = el.closest('.shopify-section') || document.body;
      var key = section.id || 'x';
      groups[key] = (groups[key] || 0) + 1;
      var i = Math.min(groups[key] - 1, 5);
      el.style.setProperty('--pj-delay', i * 80 + 'ms');
    });
  }

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pj-in');
        revealObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function observeReveals(scope) {
    scope.querySelectorAll('[data-pj-reveal]:not(.pj-in)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---- Contatori ---- */
  function formatValue(value, decimals, locale) {
    return value.toLocaleString(locale || 'it-IT', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-pj-count'));
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute('data-pj-decimals') || '0', 10);
    var prefix = el.getAttribute('data-pj-prefix') || '';
    var suffix = el.getAttribute('data-pj-suffix') || '';
    var grouping = el.getAttribute('data-pj-grouping') !== 'false';
    var duration = 1100;
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var current = target * eased;
      var text = grouping ? formatValue(current, decimals) : current.toFixed(decimals);
      el.textContent = prefix + text + suffix;
      if (p < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runCounter(entry.target);
        counterObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.5 }
  );

  function observeCounters(scope) {
    scope.querySelectorAll('[data-pj-count]').forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function init(scope) {
    var target = scope || document;
    markReveals(target);
    observeReveals(target);
    observeCounters(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Il tema ricarica le sezioni in modo dinamico (editor, filtri, paginazione). */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function () {
    root.classList.add('pj-reveal-all');
  });
})();
